import { apicall } from "../../services/api";
import { PLATFORM_REPORT_ACTIONS } from "./platformReport.actions";
import axios from 'axios';

export const getAllCampaignsReport = () => async (dispatch, getState) => {

    const availableData = getState()
    if (availableData.platformReportReducer?.campaigns?.length > 0) {
        return
    }

    dispatch({
        type: PLATFORM_REPORT_ACTIONS.PLATFORM_CAMPAIGNS_LOADING,
    });

    try {
        const res = await axios.get(`${process.env.REACT_APP_BASE_URL_VMS}/api/v2/campaigns/allcampaigns`);
      
        if (res.data.msg === "No data found.") {
            dispatch({
                type: PLATFORM_REPORT_ACTIONS.PLATFORM_CAMPAIGNS_LOADED,
                payload: [],
            });
        } else {
            dispatch({
                type: PLATFORM_REPORT_ACTIONS.PLATFORM_CAMPAIGNS_LOADED,
                payload: res.data,
            });
        }
    } catch (err) {
        dispatch({
            type: PLATFORM_REPORT_ACTIONS.PLATFORM_CAMPAIGNS_FAILURE,
            payload: {
                msg: err.response?.data?.msg || 'Something went wrong',
                status: err.response?.status || 'Unknown error',
            },
        });
    }
}